import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_PROFILE: () => ({}),
    API: {
      GET_PROFILE: apiResourceActionCreator('profile')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.Profile), authToken, actions.user.api.getProfile)

export function* getProfile() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
}

const configuration = {
  name: 'getProfile',
  action: actions,
  sagas: getProfile,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingProfile: true
    }),
    success: (state, action) => ({
      ...state,
      profile: action.payload.profile,
      isFetchingProfile: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingProfile: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getProfile.js